module.exports = __webpack_public_path__ + "media/public/fonts/QanelasSemiBold/QanelasSemiBold-3361ad740fcb3b52da165689b52ff075.ttf";